module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isManagingClassCriteria && !_vm.isManagingConcilCriteria),
      expression: "!isManagingClassCriteria && !isManagingConcilCriteria"
    }],
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('planoConciliacao.titulos.planosConciliacao'),
      "subTitle": _vm.$t('planoConciliacao.titulos.cadastroSubtitulo')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.portletTitle
    }
  }, [_c('form', {
    attrs: {
      "slot": "filters"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate.apply(null, arguments)
      }
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "planName"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.nomePlano'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.planName),
      expression: "planName"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('planName')
    },
    attrs: {
      "type": "text",
      "id": "planName",
      "name": "planName",
      "maxlength": "60"
    },
    domProps: {
      "value": (_vm.planName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.planName = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('planName')),
      expression: "errors.has('planName')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  }), _c('br')])]), _c('vue-tabs', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding-right": "0px !important"
    },
    attrs: {
      "id": "tab-navigation"
    },
    model: {
      value: (_vm.tabMain),
      callback: function($$v) {
        _vm.tabMain = $$v
      },
      expression: "tabMain"
    }
  }, [_c('v-tab', {
    staticClass: "tab",
    attrs: {
      "id": "tab-criterio-classificacai",
      "title": _vm.tabClass
    }
  }, [_c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "hint pull-left row-filter-medium"
  }, [_c('span', {
    staticClass: "bold large-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.criterios'))
    }
  }), _c('br'), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.classificationCriterias && _vm.classificationCriterias.length > 0),
      expression: "classificationCriterias && classificationCriterias.length > 0"
    }],
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.criterioReordenar'))
    }
  })]), _c('div', {
    staticClass: "pull-right row-filter-medium"
  }, [_c('button-primary', {
    attrs: {
      "label": _vm.$t('planoConciliacao.labels.addCriterio'),
      "id": "btnManageCriteria",
      "clickFunction": _vm.createOrEditCriteria
    }
  })], 1), _c('br'), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.classificationCriterias && _vm.classificationCriterias.length > 0),
      expression: "classificationCriterias && classificationCriterias.length > 0"
    }],
    staticClass: "row-filter-small",
    attrs: {
      "id": "criterias-list"
    }
  }, [_c('div', {
    staticClass: "categories-header"
  }, [_c('div', {
    staticClass: "col-md-1",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.ordem'))
    }
  }), _c('div', {
    staticClass: "col-md-4",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.descricao'))
    }
  }), _c('div', {
    staticClass: "col-md-3",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.relevancia'))
    }
  }), _c('div', {
    staticClass: "col-md-2",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.tipo'))
    }
  }), _c('div', {
    staticClass: "col-md-1",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.status'))
    }
  }), _c('div', {
    staticClass: "pull-right col-md-1"
  }, [_c('div', {
    staticClass: "criterias-header-acoes-tit",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.labels.acoes'))
    }
  })])]), _c('div', {
    staticClass: "criterias-list"
  }, [(_vm.classificationCriterias.length > 0) ? _c('draggable', {
    attrs: {
      "list": _vm.classificationCriterias
    },
    on: {
      "planCriteriaAdded": _vm.updateCriteriasList,
      "change": _vm.changeClassifOrder
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "list-complete"
    }
  }, _vm._l((_vm.classificationCriterias), function(crit, index) {
    return _c('classificationCriteria', {
      key: crit.ordem + '|' + index,
      attrs: {
        "order": index + 1,
        "criteria": crit,
        "handleEdit": _vm.createOrEditCriteria,
        "handleRemove": _vm.removeCriteriaHandler
      }
    })
  }), 1)], 1) : _vm._e()], 1)])])])]), _c('v-tab', {
    staticClass: "tab",
    attrs: {
      "id": "tab-criterio-classificacai",
      "title": _vm.tabConcil
    }
  }, [_c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "hint pull-left row-filter-medium"
  }, [_c('span', {
    staticClass: "bold large-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.criterios'))
    }
  }), _c('br'), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.conciliationCriterias && _vm.conciliationCriterias.length > 0),
      expression: "conciliationCriterias && conciliationCriterias.length > 0"
    }],
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.criterioReordenar'))
    }
  })]), _c('div', {
    staticClass: "pull-right row-filter-medium"
  }, [_c('button-primary', {
    attrs: {
      "label": _vm.$t('planoConciliacao.labels.addCriterio'),
      "id": "btnManageConcilCriteria",
      "clickFunction": _vm.createOrEditConcilCriteria
    }
  })], 1), _c('br'), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.conciliationCriterias && _vm.conciliationCriterias.length > 0),
      expression: "conciliationCriterias && conciliationCriterias.length > 0"
    }],
    staticClass: "row-filter-small",
    attrs: {
      "id": "criterias-list"
    }
  }, [_c('div', {
    staticClass: "categories-header"
  }, [_c('div', {
    staticClass: "col-md-1",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.ordem'))
    }
  }), _c('div', {
    staticClass: "col-md-4",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.descricao'))
    }
  }), _c('div', {
    staticClass: "col-md-4",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.status'))
    }
  }), _c('div', {
    staticClass: "pull-right col-md-2"
  }, [_c('div', {
    staticClass: "concil-criterias-header-acoes-tit",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.labels.acoes'))
    }
  })])]), _c('div', {
    staticClass: "criterias-list"
  }, [(_vm.conciliationCriterias.length > 0) ? _c('draggable', {
    attrs: {
      "list": _vm.conciliationCriterias
    },
    on: {
      "planCriteriaAdded": _vm.updateCriteriasList,
      "change": _vm.changeConcilOrder
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "list-complete"
    }
  }, _vm._l((_vm.conciliationCriterias), function(crit, index) {
    return _c('conciliationCriteria', {
      key: crit.ordem + '|' + index,
      attrs: {
        "order": index + 1,
        "criteria": crit,
        "handleEdit": _vm.createOrEditConcilCriteria,
        "handleRemove": _vm.removeConcilCriteriaHandler
      }
    })
  }), 1)], 1) : _vm._e()], 1)])])])])], 1), _c('br'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('planoConciliacao.labels.salvar'),
      "id": "btnSalvarPlanoDeConciliacao",
      "disabled": _vm.requestSent,
      "type": "submit"
    }
  }), _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('planoConciliacao.labels.voltar'),
      "id": "btnVoltarSalvarPlanoDeConciliacao",
      "clickFunction": _vm.back,
      "customClass": "secondary"
    }
  })], 1)])], 1)])], 1)])]), _c('newClassificationCriteria', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isManagingClassCriteria),
      expression: "isManagingClassCriteria"
    }],
    attrs: {
      "criteriaToEdit": _vm.criteriaToEdit,
      "categories": _vm.categories,
      "febraban": _vm.febraban,
      "banks": _vm.banks,
      "accounts": _vm.accounts,
      "attributesCfg": _vm.attributesCfgClassif,
      "conciliationFields": _vm.conciliationFieldsBanking
    },
    on: {
      "change-managing-plan": _vm.changeManagingClassCriteria,
      "add-criteria-to-plan": _vm.updateCriteriasList,
      "finish-load-attributes-cfg": _vm.updateCriteriasAttCfg,
      "finish-load-conciliationFields": _vm.updateCriteriasConcFields
    }
  }), _c('newConciliationCriteria', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isManagingConcilCriteria),
      expression: "isManagingConcilCriteria"
    }],
    attrs: {
      "concilCriteriaToEdit": _vm.concilCriteriaToEdit,
      "banks": _vm.banks,
      "accounts": _vm.accounts,
      "attributesCfg": _vm.attributesCfg,
      "conciliationFields": _vm.conciliationFields,
      "occurrenceReasons": _vm.occurrenceReasons
    },
    on: {
      "change-managing-plan-concil": _vm.changeManagingConcilCriteria,
      "add-concil-criteria-to-plan": _vm.updateConcilCriteriasList
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7d8ec08a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d8ec08a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/registration/conciliationPlan/new.pug
// module id = 1445
// module chunks = 0